import { CONNECTION_DATA } from "../../constants";
import { GitHub, LinkedIn, Download, Email, ContentCopy } from '@mui/icons-material';
import './Connect.css';
import { useState } from 'react';
import { MessageCircle } from 'lucide-react';
import { useLanguage } from '../../contexts/LanguageContext';
import { useMessageModal } from '../../contexts/MessageModalContext';
import content from '../../i18n/content';

export default function Connect(){
    const { lang } = useLanguage();
    const t = content[lang].footer;
    const { openModal } = useMessageModal();
    const [emailCopied, setEmailCopied] = useState(false);

    const handleEmailClick = async (e) => {
        e.preventDefault();
        const email = CONNECTION_DATA.email.title;
        try {
            await navigator.clipboard.writeText(email);
            setEmailCopied(true);
            setTimeout(() => setEmailCopied(false), 2000);
        } catch (err) {
            console.error('Failed to copy email:', err);
        }
    };

    return(
        <section id="connect" className="connect-section">
            <h2>{t.connectTitle}</h2>
            <div className="connect-items">
                <button
                    onClick={openModal}
                    className="connect-link connect-link-email"
                    aria-label="Send a direct message"
                    type="button"
                >
                    <span className="connect-icon">
                        <MessageCircle size={20} />
                    </span>
                    <span className="connect-text">{t.sendMessage}</span>
                </button>
                <button
                    onClick={handleEmailClick}
                    className="connect-link connect-link-email-copy"
                    aria-label={`Copy email ${CONNECTION_DATA.email.title}`}
                    type="button"
                >
                    <span className="connect-icon">
                        <Email fontSize="small" />
                    </span>
                    <span className="connect-text">{CONNECTION_DATA.email.title}</span>
                    <span className="connect-copy-icon">
                        {emailCopied ? (
                            <span className="copied-text">{t.copied}</span>
                        ) : (
                            <ContentCopy fontSize="small" />
                        )}
                    </span>
                </button>
                <a
                    href={CONNECTION_DATA.github.url}
                    rel="noopener noreferrer"
                    target="_blank"
                    className="connect-link"
                    aria-label="GitHub profile"
                >
                    <span className="connect-icon">
                        <GitHub fontSize="small" />
                    </span>
                    <span className="connect-text">{CONNECTION_DATA.github.title}</span>
                </a>
                <a
                    href={CONNECTION_DATA.linkedin.url}
                    rel="noopener noreferrer"
                    target="_blank"
                    className="connect-link"
                    aria-label="LinkedIn profile"
                >
                    <span className="connect-icon">
                        <LinkedIn fontSize="small" />
                    </span>
                    <span className="connect-text">{CONNECTION_DATA.linkedin.title}</span>
                </a>
                <a
                    href={CONNECTION_DATA.cv.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="connect-link"
                    aria-label={content[lang].hero.downloadCv}
                >
                    <span className="connect-icon">
                        <Download fontSize="small" />
                    </span>
                    <span className="connect-text">{content[lang].hero.downloadCv}</span>
                </a>
            </div>
        </section>
    );
}
